import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [lang, setLang] = useState('UA');
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Про нас',
    href: '#about'
  }, {
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Відгуки',
    href: '#testimonials'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/80 backdrop-blur-lg border-b border-border py-4' : 'bg-transparent py-6'}`} data-id="element-94">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-95">
        <a href="#" className="text-xl font-semibold tracking-tight text-primary" data-id="element-96">
          Адвокат
        </a>

        <div className="hidden md:flex items-center gap-8" data-id="element-97">
          <div className="flex gap-6" data-id="element-98">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-secondary hover:text-primary transition-colors" data-id="element-99">
                {link.name}
              </a>)}
          </div>

          <div className="w-px h-4 bg-border" data-id="element-100"></div>

          <div className="flex items-center gap-4" data-id="element-101">
            <div className="flex gap-2 text-sm font-medium" data-id="element-102">
              <button onClick={() => setLang('UA')} className={`transition-colors ${lang === 'UA' ? 'text-primary' : 'text-secondary hover:text-primary'}`} data-id="element-103">
                UA
              </button>
              <span className="text-border" data-id="element-104">/</span>
              <button onClick={() => setLang('RU')} className={`transition-colors ${lang === 'RU' ? 'text-primary' : 'text-secondary hover:text-primary'}`} data-id="element-105">
                RU
              </button>
            </div>
          </div>

          <a href="#contact" className="px-5 py-2.5 bg-primary text-background text-sm font-medium rounded-full hover:opacity-90 transition-opacity" data-id="element-106">
            Зв'язатися
          </a>
        </div>

        <div className="md:hidden flex items-center gap-4" data-id="element-107">
          <button className="text-primary p-1" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-108">
            {isMobileMenuOpen ? <X size={24} data-id="element-109" /> : <Menu size={24} data-id="element-110" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background border-b border-border p-6 flex flex-col gap-4 md:hidden shadow-lg" data-id="element-111">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-primary py-2" data-id="element-112">
              {link.name}
            </a>)}
          <div className="flex gap-4 py-2 text-lg font-medium border-t border-border mt-2 pt-4" data-id="element-113">
            <button onClick={() => {
          setLang('UA');
          setIsMobileMenuOpen(false);
        }} className={lang === 'UA' ? 'text-primary' : 'text-secondary'} data-id="element-114">
              UA
            </button>
            <button onClick={() => {
          setLang('RU');
          setIsMobileMenuOpen(false);
        }} className={lang === 'RU' ? 'text-primary' : 'text-secondary'} data-id="element-115">
              RU
            </button>
          </div>
          <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 px-6 py-3 bg-primary text-background text-center font-medium rounded-full" data-id="element-116">
            Зв'язатися
          </a>
        </div>}
    </motion.nav>;
}